import { frontendURL } from 'dashboard/helper/URLHelper.js';

import NotificacoesPageRouteView from './pages/NotificacoesPageRouteView.vue';
import NotificacoesListPage from './pages/NotificacoesListPage.vue';
import AutoRespostasPage from './pages/AutoRespostasPage.vue';
import ContactListPage from 'dashboard/components-next/ContactLists/ContactListPage.vue';
import EmailConfigPage from './pages/EmailConfigPage.vue';

const notificacoesRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/notificacoes'),
      component: NotificacoesPageRouteView,
      children: [
        {
          path: '',
          redirect: to => ({
            name: 'notificacoes_list',
            params: to.params,
          }),
        },
        {
          path: 'list',
          name: 'notificacoes_list',
          component: NotificacoesListPage,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'auto_respostas',
          name: 'notificacoes_auto_replies',
          component: AutoRespostasPage,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'listas_contatos',
          name: 'notificacoes_contact_lists',
          component: ContactListPage,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'email_config',
          name: 'notificacoes_email_config',
          component: EmailConfigPage,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};

export default notificacoesRoutes;
